module.exports = "<html-post post=\"vm.post\" on-delete=\"vm.onDelete(post)\" is-expanded=\"true\"></html-post>\n";